import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { AccessibilityServiceChannelLinkComponent } from '../../accessibility-service-channel-link/accessibility-service-channel-link.component';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
  imports: [CommonModule, AccessibilityServiceChannelLinkComponent]
})
export class ContactsComponent {}
